import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import Header from './components/Header';
import ProtectedRoute from './utils/ProtectedRoute/ProtectedRoute';
import Home from './containers/Home/Home';

// Use empty string as default for development
const basename = process.env.PUBLIC_URL || '';

function App() {
    return (
        <BrowserRouter basename={basename}>
            <div>
                <Header />
                <Routes>
                    <Route
                        path='/'
                        element={
                            <ProtectedRoute>
                                <Home />
                            </ProtectedRoute>
                        }
                    />
                    <Route path='/login' element={<LoginForm />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
